// Import dependencies
import React, { createElement } from "react";

// Import motion library
import { motion } from "framer-motion";

// Import styles
import "./ServiceCard.css";

// Framer motion configuration
const card = {
  hidden: {
    scale: 0,
  },

  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const ServiceCard = (props) => {
  // Props with the service information
  const { id, title, text, icon } = props.service;

  return (
    <motion.li
      className="service__box w-[18rem] h-[40vh] bg-white_txt py-[1.5rem] px-[2rem] mr-[8rem] rounded-tr-[50px] rounded-bl-[50px] flex flex-col flex-1 justify-evenly hover:bg-gray"
      key={id}
      variants={card}
    >
      <div className="mx-auto text-[3rem] text-dark_primary">
        {createElement(icon)}
      </div>

      <h6 className="my-3 text-center">{title}</h6>

      <p className="leading-7 text-center mt-3">{text}</p>
    </motion.li>
  );
};

export default ServiceCard;
